import { Component, Input, OnInit } from '@angular/core';
import { FieldConfig } from '../dynamic-form/dynamic-form-config.interface';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-boolean-selection',
  templateUrl: './boolean-selection.component.html',
  styleUrls: ['./boolean-selection.component.scss']
})
export class BooleanSelectionComponent implements OnInit {

  @Input() field: FieldConfig;
  @Input() group: FormGroup;

  constructor() { }

  ngOnInit(): void {
    if (this.field && this.field.label && this.field.label==='true'){
      this.setValue(true);
    }
  }

  setValue(value: boolean): void {
    this.group.controls[this.field.name].setValue(value);
  }

}
